<template>
  <div class="formWrapper mb-5">
    <div class="formWrapper__header">
      <Icon icon="delivery" class="formWrapper__header__icon" />
      <h3 v-if="main !== true">Punkt dostawy {{delivery_id + 1}}</h3>
    </div>
    <div class="formWrapper__inner">
      <delivery-addres-form :delivery_id="delivery_id" v-if="!main"></delivery-addres-form>
      <h3>Produkty do wysłania</h3>
      <product-form :delivery_id="delivery_id" :main="main"></product-form>
      <upload-file v-if="!main" :delivery_id="delivery_id"></upload-file>
    </div>
  </div>
</template>

<script>
import ProductForm from './ProductForm.vue';
import DeliveryAddresForm from '../DeliveryAddressForm/DeliveryAddressForm.vue';
import UploadFile from '../Upload/UploadFile.vue';
import Icon from '../Icon.vue';

export default {
  name: 'ProductFormWrapper',
  components: {
    UploadFile,
    DeliveryAddresForm,
    ProductForm,
    Icon,
  },
  props: ['delivery_id', 'main'],
  data() {
    return {};
  },
};
</script>

<style scoped>

</style>
